import { SamplesLayout } from "../../search/@types";
import { useGridConfig } from "../../search/hooks";
import { LayoutsResponse } from "../components/layout-editor/@types";
import { useGetLayouts } from "../components/layout-editor/hooks";

export const getSelectedLayout = (
  selected?: SamplesLayout,
  layouts?: LayoutsResponse
) => {
  if (!layouts || !selected) return undefined;

  const typeLayouts = layouts[selected?.type] ?? [];
  const layout = typeLayouts?.find(item => item.id === selected?.id);

  if (layout) return { ...selected, name: layout.name };

  const firstRlLayout = layouts.rl.at(0);
  if (!firstRlLayout) return undefined;

  const { id, name } = firstRlLayout;
  return { id, name, type: "rl" };
};

const useGetSelectedLayout = () => {
  const { gridConfig } = useGridConfig();
  const { data: layouts } = useGetLayouts();

  const { samples_layout: selected } = gridConfig ?? {};
  // use first rl default as default in case that there is no selected or selected could not be found
  const selectedLayout = getSelectedLayout(selected, layouts);

  return selectedLayout;
};

export default useGetSelectedLayout;
